import { getCalendarIdByFolderId } from 'owa-calendar-cache';

export function getCalendarIdsFromFolderIds(folderIds: string[]): string[] {
    let calendarIds = [];
    folderIds.forEach(folderId => {
        const calendarId = getCalendarIdByFolderId(folderId);
        // getCalendarIdByFolderId could return null for group calendar
        // Remove this null check once group calendar initialization is moved under /common
        // https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/49088
        if (calendarId) {
            calendarIds.push(calendarId.id);
        }
    });
    return calendarIds;
}
